import { ISpecialist } from '../../../types/specialist';
import { declineNumeric } from '../../../utils/format_helper';

export const getSummaryRealtors = (s: ISpecialist) =>
  `${s.offersCount} ${declineNumeric(s.offersCount, ['предложение', 'предложения', 'предложений'])}`;

export const getSummaryAgencies = (s: ISpecialist) => getSummaryRealtors(s);

export const getSummaryDevelopers = (s: ISpecialist) =>
  `${s.offersCount} ${declineNumeric(s.offersCount, ['квартира', 'квартиры', 'квартир'])}` +
  ` в ${s.newobjectsCount} ЖК `;
